import * as React from "react";
import { Box } from "@mui/material";

export default function Footer() {
  const [value, setValue] = React.useState(0);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        left: "50%",
        transform: "translateX(-50%)",
        bottom: 0,
        bgcolor: "#29417c",
        // "#bbb9b9",
        // "black",
        color: "#c2c2c2",
        // "#6b6b6b",
        //  "#ccc",
        fontSize: "13px",
        height: "28px",
        width: "400px",
        zIndex: 1000,
        borderRadius: "3px",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <p>&copy; 2024 Tyger Capital. All rights reserved. v.2.1.0.1</p>
      </div>
    </Box>
  );
}
